import { notification } from 'antd';
import axios from 'axios';
import dayjs from 'dayjs';
import excel from 'exceljs';

export function newObjectKeys(originalObject, necessaryKeys) {
  return Object.fromEntries(
    Object.entries(originalObject)
      .filter(([key, value]) => necessaryKeys.includes(key))
      .map(([key, value]) => [key, value])
  );
}

// Hardcode cố định: endpoint này nhận mọi loại file, không giới hạn 5MB và trả về
// { status, path } đúng shape hàm dưới đang đọc. Trước đây lấy từ
// REACT_APP_UPLOAD_FILE_API_ENDPOINT, nhưng biến đó từng bị trỏ sang
// /json/api/cms/miniapp/upload-image (multer chặn 5MB + chỉ nhận ảnh) làm hỏng
// upload file/video của Quản trị nội dung, nên không phụ thuộc env nữa.
export const UPLOAD_CDN_ENDPOINT = 'https://cdn.lichviet.org/common-api/single-upload';

export async function uploadImageCDN(img, callback, uploadFolder = '') {
  const FILE_UPLOAD = UPLOAD_CDN_ENDPOINT;
  const data = new FormData();
  data.append('files', img);
  data.append('uploadFolder', uploadFolder);
  const user = localStorage.getItem('user');
  const decodeUser = JSON.parse(user);
  const response = await axios
    .post(FILE_UPLOAD, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${decodeUser?.token}`,
      },
    })
    .catch((err) => {
      console.log(err);
      return err;
    });

  if (response?.data?.status) {
    callback(response.data?.path);
    return response.data?.path;
  } else {
    callback('');
    notification.error({
      message: response?.data?.message || 'Có lỗi xảy ra, vui lòng thử lại!',
    });
  }
}

export const formatPrice = (n, str = '.') => {
  var a = n?.toString().replaceAll('.', '').replaceAll(',', '');
  return a?.replace(/./g, function (c, i, a) {
    return i > 0 && c !== str && (a.length - i) % 3 === 0 ? str + c : c;
  });
};

export const formatNumber = (value) => {
  if ((value == null || value === undefined || value === '') && (value !== 0 || value !== '0')) {
    return '';
  }
  if (!isNaN(value)) {
    return Number(value).toLocaleString('de-DE');
  }
  return value.toString();
};

export const dataToOptionSelect = (data, label = 'name', value = 'id') => {
  return data?.map((item) => ({
    label: item[label],
    value: item[value],
  }));
};

// Parse chuỗi JSON từ DB (cột columns/metadata) — dữ liệu cũ có thể null/rỗng/sai format
export const safeParseArray = (raw) => {
  try {
    const value = JSON.parse(raw);
    return Array.isArray(value) ? value : [];
  } catch (e) {
    return [];
  }
};

export const safeParseObject = (raw) => {
  try {
    const value = JSON.parse(raw);
    return value && typeof value === 'object' && !Array.isArray(value) ? value : {};
  } catch (e) {
    return {};
  }
};

// Cột động (event_type.columns / object_type.columns) chuẩn là JSON mảng tên cột,
// nhưng dữ liệu cũ nhập tay qua textarea có thể là JSON object — lấy values để không mất dữ liệu
export const safeParseColumns = (raw) => {
  try {
    const value = JSON.parse(raw);
    if (Array.isArray(value)) return value.map(String).filter(Boolean);
    if (value && typeof value === 'object') return Object.values(value).map(String).filter(Boolean);
    return [];
  } catch (e) {
    return [];
  }
};

// Xuất một bảng phẳng ra .xlsx: headers là mảng tiêu đề cột, rows là mảng các mảng ô
// (cùng thứ tự với headers). Tách riêng khỏi exportTableToExcelNew vì hàm đó bị bó cứng
// cho dạng thống kê (fixedColumns + dòng "Tổng" merge cell).
export const exportRowsToExcel = async (headers, rows, filename = 'export', sheetName = '') => {
  const workbook = new excel.Workbook();
  const worksheet = workbook.addWorksheet(sheetName || dayjs().format('DD-MM-YYYY'));

  worksheet.columns = headers.map((header, index) => ({
    header,
    // exceljs cần key duy nhất cho mỗi cột; tiêu đề tiếng Việt có thể trùng nhau nên dùng index
    key: `c${index}`,
    width: Math.min(Math.max(String(header).length + 6, 14), 40),
  }));
  worksheet.getRow(1).font = { bold: true };

  rows.forEach((row) => worksheet.addRow(row));

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `${filename}.xlsx`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};

export const exportTableToExcelNew = (data, filename = '') => {
  let workbook = new excel.Workbook();
  let worksheet = workbook.addWorksheet(`${dayjs().format('DD-MM-YYYY')}`);

  data.data = data.data.map((item) => {
    const { type, id, key, ...rest } = item;
    return rest;
  });

  worksheet.columns = Object.keys(data.data[0]).map((key) => ({
    header: key,
    key: key,
    width: 20,
  }));

  for (let i = 0; i < data.data.length; ++i) {
    const statistic = data.data[i];
    let rowExcel = {};
    Object.keys(statistic).map((key) => {
      rowExcel = Object.assign(rowExcel, {
        [key]: statistic[key],
      });
    });

    worksheet.addRows([rowExcel]);
  }

  let rowExcel = {};

  rowExcel[worksheet.getCell('A1').value] = 'Tổng';

  for (const dataRow of data.fixedColumns) {
    rowExcel = Object.assign(rowExcel, {
      [dataRow['name']]: formatNumber(dataRow['value']),
    });
  }

  worksheet.addRows([rowExcel]);
  let lastRowIndex = worksheet.rowCount;
  let endColumnLetter = String.fromCharCode('A'.charCodeAt(0) + data.colSpan - 1);
  worksheet.mergeCells(`A${lastRowIndex}:${endColumnLetter}${lastRowIndex}`);

  workbook.xlsx
    .writeBuffer()
    .then((buffer) => {
      let blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = url;
      a.download = `${filename ?? 'output'}.xlsx`; // Tên file muốn lưu
      document.body.appendChild(a);
      a.click();
      a.remove(); // Sau khi tải về, xóa element a khỏi DOM
    })
    .catch((error) => {
      console.error('Error writing file:', error);
    });
};
export const validatePhoneNumber = (value) => {
  const phoneRegex = /^[0-9]{10}$/;
  return phoneRegex.test(value);
};
